import { render, staticRenderFns } from "./ShareRide.vue?vue&type=template&id=51380130&scoped=true"
import script from "./ShareRide.vue?vue&type=script&lang=js"
export * from "./ShareRide.vue?vue&type=script&lang=js"
import style0 from "./ShareRide.vue?vue&type=style&index=0&id=51380130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51380130",
  null
  
)

export default component.exports